import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-copyable-message',
  templateUrl: './copyable-message.component.html',
  styleUrls: ['./copyable-message.component.scss'],
})
export class CopyableMessageComponent {
  /** When set, this string is shown. Otherwise use projected content. */
  @Input() message: string;
  @Input() variant: 'danger' | 'warning' = 'danger';
  @Input() extraClass = '';

  @ViewChild('body') body?: ElementRef<HTMLDivElement>;

  copied = false;

  copy(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const text = (this.body?.nativeElement?.textContent || '').trim();
    if (!text) {
      return;
    }
    this.writeClipboard(text).then((ok) => {
      if (ok) {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      }
    });
  }

  private async writeClipboard(text: string): Promise<boolean> {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch {
      /* fall through */
    }
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}
